var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.83 8.70031L15.3 4.17031C14.8306 3.69962 14.2676 3.33268 13.6475 3.09325C13.0274 2.85381 12.3639 2.7472 11.7 2.78031L6.69998 3.02031C4.69998 3.11031 3.10998 4.70031 3.00998 6.69031L2.76998 11.6903C2.70998 13.0303 3.20998 14.3403 4.15998 15.2903L8.68997 19.8203C9.58599 20.7137 10.7997 21.2154 12.065 21.2154C13.3303 21.2154 14.544 20.7137 15.44 19.8203L19.83 15.4303C20.2744 14.9898 20.6271 14.4657 20.8678 13.8881C21.1086 13.3105 21.2325 12.691 21.2325 12.0653C21.2325 11.4396 21.1086 10.8201 20.8678 10.2425C20.6271 9.66496 20.2744 9.1408 19.83 8.70031ZM9.49998 12.3803C7.91998 12.3803 6.61998 11.0903 6.61998 9.50031C6.61998 7.91031 7.91998 6.62031 9.49998 6.62031C11.08 6.62031 12.38 7.91031 12.38 9.50031C12.38 11.0903 11.08 12.3803 9.49998 12.3803ZM17.53 13.5303L13.53 17.5303C13.38 17.6803 13.19 17.7503 13 17.7503C12.81 17.7503 12.62 17.6803 12.47 17.5303C12.3305 17.3892 12.2523 17.1987 12.2523 17.0003C12.2523 16.8019 12.3305 16.6114 12.47 16.4703L16.47 12.4703C16.76 12.1803 17.24 12.1803 17.53 12.4703C17.82 12.7603 17.82 13.2403 17.53 13.5303Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranded);
export default __webpack_public_path__ + "static/media/branded.603256e5c6511c929db111f62391c129.svg";
export { ForwardRef as ReactComponent };